import { DynamicForm } from "@/components/dynamic-form";
import { getInitialValues } from "@/components/dynamic-form/helper/getInitialValues";
import { useDynamicForm } from "@/components/dynamic-form/hook/useDynamicForm";
import { PageContainer } from "@/components/page-container";
import { TableContainer } from "@/components/table-container";
import { AddButton, PlusIcon } from "@/pages/child-customer/atom";
import { useGlobalStore } from "@/store/GlobalStore";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { Table } from "@renderbus/ui";
import { SearchAreaWrapper } from "./atom";
import AddOrEditProjectModal from "./components/add-or-edit-project-drawer";
import { getColumns } from "./config/table-columns";
import { useAddProject } from "./hook/useAddProject";
import { useProjectSearch } from "./hook/useProjectSearch";
import { useSearchConfig } from "./hook/useSearchConfig";
import { ProjectStoreProvider } from "./store/project-store";
import { Project } from "./types";

export function ProjectManageView() {
  const { form, getSearchParams } = useDynamicForm({
    api: "/api/rendering/task/common/queryProjectAllInfo",
    noPagination: true,
  });
  const { searchConfig } = useSearchConfig();
  const {
    open,
    dataSource,
    targetKeys,
    onSelectChange,
    onOpen,
    onStateChange,
    onAdd,
    projectForm,
    params,
    setParams,
    handleRemoveChange,
  } = useAddProject();
  const t = getTranslateNsT("center");
  const { userInfo } = useGlobalStore();
  const isProjectLockedOpen = !!userInfo?.projectLocked;
  const { searchResult, search } = useProjectSearch("projectName");
  return (
    <TableContainer>
      <SearchAreaWrapper>
        <AddButton type="primary" icon={<PlusIcon />} onClick={() => onOpen()}>
          {t("user_com_childPro_btn_add")}
        </AddButton>
        <DynamicForm
          initialValues={getInitialValues(searchConfig)}
          searchConfig={searchConfig}
          searchForm={form}
          onSearch={() => search(getSearchParams()["projectName"])}
          showButtonIcon
        />
      </SearchAreaWrapper>
      <Table
        columns={getColumns(isProjectLockedOpen)}
        dataSource={searchResult}
        pagination={false}
        hidePaginationOnSinglePage={true}
      />
      <AddOrEditProjectModal
        projectForm={projectForm}
        operationType={Project.OperationType.ADD}
        open={open}
        onOk={onAdd}
        onCancel={() => onStateChange(false)}
        params={params}
        setParams={setParams}
        transferProps={{
          showSelectAll: false,
          dataSource,
          targetKeys,
          selectedKeys: [],
          onSelectChange,
          handleRemoveChange,
        }}
      />
    </TableContainer>
  );
}
export function ProjectManage() {
  return (
    <ProjectStoreProvider>
      <PageContainer>
        <ProjectManageView />
      </PageContainer>
    </ProjectStoreProvider>
  );
}
